module.exports = __webpack_public_path__ + "media/functional__son_1.f22a1596.webm";